import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'etiquetas',
  standalone: true
})
export class EtiquetasPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const etiquetas = value.split(',').map(e => e.trim());
    return etiquetas.map(etiqueta =>
      `<span class="etiqueta-tabla">${etiqueta}</span>`
    ).join(' ');
  }
}
